import { render } from "./ModalApplyForLeaveCarryforward.vue?vue&type=template&id=b2eed8dc"
import script from "./ModalApplyForLeaveCarryforward.vue?vue&type=script&lang=js"
export * from "./ModalApplyForLeaveCarryforward.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__